import { criancaFunc, vrCriancaFunc } from "../../helpers/Funcionalidades";

export const handleVerifyMovimento = (options, roleKeycloack, user, idPJ) => {
  const permissions = [
    {
      check: () => !(roleKeycloack.includes(vrCriancaFunc.movimentoAcolhimentoCadastrar) || ((roleKeycloack?.includes(criancaFunc.visualizarTudoAcolhimento) || (roleKeycloack?.includes(criancaFunc.visualizarTudoTutelar))) &&
        user?.orgaoExterno?.includes(idPJ))),
      idsToRemove: [3],
    },
    {
      check: () => !(roleKeycloack.includes(vrCriancaFunc.movimentoDesligamentoCadastrar) || ((roleKeycloack?.includes(criancaFunc.visualizarTudoAcolhimento) || (roleKeycloack?.includes(criancaFunc.visualizarTudoTutelar))) &&
        user?.orgaoExterno?.includes(idPJ))),
      idsToRemove: [4],
    },
    {
      check: () => !(roleKeycloack.includes(vrCriancaFunc.movimentoTransferenciaEntradaCadastrar) || ((roleKeycloack?.includes(criancaFunc.visualizarTudoAcolhimento) || (roleKeycloack?.includes(criancaFunc.visualizarTudoTutelar))) &&
        user?.orgaoExterno?.includes(idPJ))),
      idsToRemove: [1],
    },
    {
      check: () => !(roleKeycloack.includes(vrCriancaFunc.movimentoTransferenciaSaidaCadastrar) || ((roleKeycloack?.includes(criancaFunc.visualizarTudoAcolhimento) || (roleKeycloack?.includes(criancaFunc.visualizarTudoTutelar))) &&
        user?.orgaoExterno?.includes(idPJ))),
      idsToRemove: [2],
    },
    {
      check: () => !(roleKeycloack.includes(vrCriancaFunc.movimentoTransferenciaFamiliarCadastrar) || ((roleKeycloack?.includes(criancaFunc.visualizarTudoAcolhimento) || (roleKeycloack?.includes(criancaFunc.visualizarTudoTutelar))) &&
        user?.orgaoExterno?.includes(idPJ))),
      idsToRemove: [6],
    },
  ];

  return options.filter(item => {
    return !permissions.some(permission => permission.check() && permission.idsToRemove.includes(item.id));
  });
};